import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: inline-block;
  width: 22px;
  height: 22px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  svg {
    width: 18px;
    height: 18px;
  }
`;
